// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__217oq","sendOtp":"AuthorizeToLogin_sendOtp__3SnbC"};